<template>
  <v-footer
    dark
    padless
    
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="teal">
        <strong class="subtitle-1 text-md-h6 text-sm-h6 text-xs-h6  textWordBreak">Нас учили добру....видно плохо учили - Мы в ответе за тех, кого приручили.</strong>

        <v-spacer></v-spacer>
<!-- v-for="icon in icons"
          :key="icon" -->
        <a target="blank" class="text-decoration-none"  href="https://vk.com/pravo_na_zhiznye">
        <v-btn
          class="mx-4"
          dark
          icon
        >
          <v-icon size="24px">
            mdi-vk
          </v-icon>
        </v-btn>
        </a>
      </v-card-title>
      <a target="blank" class="text-decoration-none"  href="https://csfs-2020.blogspot.com/2020/02/ms-excel-vba-cms-joomla-chronoforms.html#more">
      <v-card-text class="py-2 white--text text-center">
        {{ new Date().getFullYear() }} — <strong>C.S.F.S.</strong>
      </v-card-text>
      </a>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      // icons: [
      //   'mdi-facebook',
      //   // 'mdi-twitter',
      //   'mdi-vk',
      //   'mdi-instagram',
      // ],
    }),
  }
</script>

<style  scoped>
.textWordBreak {
  word-break: break-word !important;
  white-space: normal !important;
}
</style>